<template>
    <div class="container">
        <div v-if="list.length == 0" class="index-empty">
            <div class="index-empty-box">
                <div class="imageEmptySearch">
                    <img src="../../../../assets/images/search.png" alt />
                </div>
                <div style="text-align: center;color: #92909a;">{{ regMes }}</div>
            </div>
        </div>
        <div v-if="list.length > 0" style="height: 100%; overflow: auto;">
            <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: calc(100% - 0.2vw); overflow: auto"
      > -->
            <van-list v-model="loading" :finished="finished" finished-text="到底啦~" @load="onLoad"
                style="padding-top: 4px;">
                <div v-for="item in list" :key="item.id">
                    <div class="list">
                        <div class="everylist flex">

                            <div class="avatar" v-if="item.avatarUrl">
                                <img :src="item.avatarUrl" alt="" style="border-radius: 50%" />
                            </div>
                            <div class="avatar" v-else>
                                <img class="avatar" src="../../../../assets/images/default.jpeg" alt=""
                                    style="border-radius: 50%" />
                            </div>
                            <p class="name-list">{{ item.nickName }}</p>
                        </div>
                    </div>
                </div>
            </van-list>
            <!-- </van-pull-refresh> -->
        </div>
        <van-overlay :show="isLoading">
            <div class="wrapper">
                <loading v-if="isLoading == true"></loading>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import {
    Dialog,
    List,
    PullRefresh,
    Loading,
    Toast,
    Overlay
} from "vant";
import service from "../../../api/user/partnerList";
// import { mapGetters } from "vuex";
import loading from "../../../components/loading/loading";
export default {
    components: {
        [Dialog.name]: Dialog,
        [List.name]: List,
        [PullRefresh.name]: PullRefresh,
        [Loading.name]: Loading,
        [Toast.name]: Toast,
        [Overlay.name]: Overlay,
        loading
    },
    data() {
        return {
            regMes: '',
            isLoading: true, //loading状态
            page: 1,
            pageSize: 10,
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            firstLoading: true
        };
    },
    // computed: {
    //     ...mapGetters(["userInfo"])
    // },
    mounted() {
        this.pageSize = 10;
        this.init();
    },
    methods: {
        onLoad() {
            this.page++;
            setTimeout(() => {
                this.isLoading = false;
            }, 500);
            this.getList().then((list) => {
                this.list = this.list.concat(list.items);
                this.loading = false;
                if (list.totalRows <= this.list.length) {
                    this.finished = true;
                }
            });
        },
        getList() {
            return new Promise((resolve, reject) => {
                service
                    .list(
                        this.page, this.pageSize,
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                        this.regMes = error
                        console.log(error, 107)
                        reject();
                    });
            });
        },
        init() {
            this.page = 1;
            this.firstLoading = true;
            this.loading = false;
            this.getList().then((list) => {
                this.firstLoading = false;
                setTimeout(() => {
                    this.isLoading = false;
                }, 500);
                this.finished = false;
                console.log(list, 121)
                if (list.items.length !== 0) {
                    this.list = list.items;

                    if (list.totalRows <= this.list.length) {
                        this.loading = false;
                        this.finished = true;
                    }
                    // else{
                    //   this.onLoad()
                    // }
                } else {
                    console.log(list, 132)
                    this.list = [];
                    this.loading = false;
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.container {
    // height: calc(100% - 0.2vw);
    font-size: 15px;

    p {
        margin: 1.6vw 0;
    }

    .name-list {
        margin-left: 10px;
    }

    .everylist {
        border-bottom: 1px solid #e6e6e6;
        margin: 0 0.15rem;
        height: 14.8vw;
        line-height: 14.8vw;
        padding: 4vw 0;
    }

    .list {
        padding: 0 3.7vw;
        background: #fff;
    }

    .avatar {
        width: 40px;
        height: 40px;
    }

}
</style>